import axios from "axios";
import { unsubscribe } from "../gamerClubApi";

/**
 * Equivalent of Angular LibyaService
 */
const baseURL = "https://vas1.gtmultiverse.com/api/gamerClub";

const LibyaService = {
  /* ================= MCP Shield ================= */
  checkMCPShieldLibya() {
    return axios.get(
      `${baseURL}/libya-d/antifraud?targeted_element=cta_button`
    );
  },
  getSubDetails() {
    return axios.get(
      `${baseURL}/libya-d/getSubDetails?phone=${localStorage.getItem("msisdn")}`
    );
  },
 getSubDetailsLibya() {
  const phone= localStorage.getItem("msisdn");
    return axios.get(
      `${baseURL}/libya-d/getSubDetails?phone=${phone}`
    );
  },
  signInLibya(phone) {
    return axios.get(
      `${baseURL}/libya-d/signIn?phone=${encodeURIComponent(phone)}`
    );
  },
  /* ================= SEND PIN ================= */
  sendPinLibya(msisdn, transaction_identify) {
    return axios.get(
      `${baseURL}/libya-d/subscribe`,
      {
        params: {
          phone: msisdn,
          transaction_identify,
        },
      }
    );
  },

  /* ================= VERIFY OTP ================= */
  verifyLibya(msisdn, otp, trafficsource = null, parameter = null) {
    let url = `${baseURL}/libya-d/verify?phone=${msisdn}&otp=${otp}`;

    if (
      trafficsource &&
      trafficsource !== "undefined" &&
      trafficsource !== "null"
    ) {
      url += `&company=${trafficsource}`;
    }

    if (
      parameter &&
      parameter !== "undefined" &&
      parameter !== "null"
    ) {
      url += `&key=${parameter}`;
    }

    return axios.get(url);
  },
  unsubscribeLibya(msisdn) {
    return axios.post(
      `${baseURL}/libya-d/unsubscribe`,
      { phone: msisdn }
    );
  },
  /* ================= ACTIVATE SUBSCRIPTION ================= */
  activateSubscriptionApi: (payload) => {
  return axios.post(`${baseURL}/libya-d/sendActivateOTP`, payload);
},

  verifyOtpApi: (payload) => {
  return axios.post(`${baseURL}/libya-d/activate`, payload);
},
unsubscribeApi: (payload) => {
  return axios.post(`https://api.gamerclub.live/api/unsubscribe`, payload); 
},

  getSubscriptionList(phone) {
    return axios.get(`${baseURL}/libya-d/subscription-list`, {
      params: { phone },
    });
  },

  upgradePackage(payload) {
    return axios.post(`${baseURL}/libya-d/upgrade`, payload);
  },

  upgradeConfirm(payload) {
    return axios.post(`${baseURL}/libya-d/upgrade-confirm`, payload);
  },

};

/**
 * Helper function to process subscription details and update localStorage
 * Call this after getSubDetails or getSubDetailsLibya returns data
 * @param {Object} data - The subscription data from API (res?.data?.data)
 */
export const updateSubscriptionStorage = (data) => {
  if (!data) return;

  localStorage.setItem("created_at", data.created_at);
  localStorage.setItem("expiration_date", data.expiration_date);

  const today = new Date();
  const expirationDate = new Date(data.expiration_date);
  const isExpired = expirationDate < today;
  const status = (data.status || data.subscription_status || "").toString().toUpperCase();

  // ACTIVE/CANCELLED + expiration in future → has access
  // ACTIVE/CANCELLED + expiration in past → no access (show modal when they try to play)
  const canPlay = !isExpired;

  localStorage.setItem("can_play", JSON.stringify(canPlay));
  localStorage.setItem("can_cancel", data.can_cancel);
  localStorage.setItem("has_access", data.has_access);
  localStorage.setItem("subscription_status", status);

  if (!canPlay) {
    // ACTIVE + expired → "You do not have enough balance."
    // CANCELLED + expired → "You need to reactivate your subscription."
    const blockReason = status === "ACTIVE" ? "no_balance" : "reactivate";
    localStorage.setItem("subscription_block_reason", blockReason);
  } else {
    localStorage.removeItem("subscription_block_reason");
  }
};

export default LibyaService;
